export enum UserRoles {
  ADMIN = "Admin",
  PUBLICATION_MANAGER = "Publication Manager",
  LOCALIZATION_MANAGER = "Localization Manager",
  ENGINEER = "Engineer",
  TECHNICAL_WRITER = "Technical Writer",
  REVIEWER = "Reviewer",
  KCS_READONLY_REVIEWER = "KCS Readonly Reviewer",
  CONTENT_REVIEWER = "Content Reviewer"
}